import { Button } from '../../interfaces/controller';
import { StandardController } from './standard-controller';

/**
 * Anything a button source (keyboard, gamepad, tests) can write to.
 * StandardController satisfies this structurally, so a mux is optional.
 */
export interface ButtonSink {
    setButton(button: Button, pressed: boolean): void;
}

/**
 * Merges multiple input sources (keyboard + gamepad) onto one
 * StandardController without them clobbering each other: each source owns a
 * private mask, and the OR of all masks is applied to the controller.
 */
export class InputMux implements ButtonSink {
    private controller: StandardController;
    private keyboardMask: number = 0;
    private gamepadMask: number = 0;

    constructor(controller: StandardController) {
        this.controller = controller;
    }

    /** Keyboard source entry point (per-button). */
    setButton(button: Button, pressed: boolean): void {
        const bit = 1 << (button & 0x07);
        this.keyboardMask = pressed ? (this.keyboardMask | bit) : (this.keyboardMask & ~bit);
        this.apply();
    }

    releaseKeyboard(): void {
        this.keyboardMask = 0;
        this.apply();
    }

    /** Gamepad source entry point (whole mask, bit 0 = A ... bit 7 = Right). */
    setGamepadMask(mask: number): void {
        this.gamepadMask = mask & 0xFF;
        this.apply();
    }

    private apply(): void {
        this.controller.setButtonMask(this.keyboardMask | this.gamepadMask);
    }
}
